import { createAction } from '@reduxjs/toolkit';
import { IBroadcastMessagesState } from '@store/broadcast-messages/types';

export class GetUsersCountFailure {
  static get action() {
    return createAction('broadcastMessages/GET_USERS_COUNT_FAILURE');
  }

  static get reducer() {
    return (draft: IBroadcastMessagesState) => {
      draft.requests.getUserCountPending = false;

      return draft;
    };
  }
}
